import { render, staticRenderFns } from "./TranUserPackageUpdate.vue?vue&type=template&id=4f9e67f1&scoped=true"
import script from "./TranUserPackageUpdate.vue?vue&type=script&lang=js"
export * from "./TranUserPackageUpdate.vue?vue&type=script&lang=js"
import style0 from "./TranUserPackageUpdate.vue?vue&type=style&index=0&id=4f9e67f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9e67f1",
  null
  
)

export default component.exports